import Layout from "../components/Layout";

/**
 * Drivons Terms of Service — reflects the ACTUAL platform mechanics.
 */
export default function Terms() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto p-6 prose prose-invert" data-testid="terms-page">
        <h1>Drivons — Terms of Service</h1>
        <p><i>Last updated: February 2026</i></p>

        <h2>1. The platform</h2>
        <p>Drivons is a marketplace. We do not employ drivers, movers, mechanics,
        couriers, or other suppliers. We connect independent service providers
        with customers who need their services. All service contracts are
        directly between customer and supplier; Drivons takes a platform
        commission on each completed order.</p>

        <h2>2. Eligibility</h2>
        <p>You must be at least 18 and legally able to enter into contracts.
        Suppliers must additionally hold any licenses their trade requires
        (driver's license, commercial insurance, vehicle registration, etc.)
        and are responsible for keeping those current.</p>

        <h2>3. Pricing</h2>
        <ul>
          <li>Fares are calculated based on distance + duration + category
          rates + surge multiplier when active. You will always see the
          quoted fare before you confirm the order.</li>
          <li>For orders in currencies that our PayPal merchant account
          does not accept directly (e.g. Turkish Lira), Drivons converts the
          amount to USD at the time of payment using European Central Bank
          rates. The conversion is shown before you approve the charge.</li>
          <li>Drivons's platform commission is disclosed in the fare breakdown.</li>
        </ul>

        <h2>4. Payments</h2>
        <ul>
          <li>PayPal (Live) and Cash are the only supported payment methods.</li>
          <li>PayPal payments are processed by PayPal and subject to their terms.</li>
          <li>Cash payments are collected directly by the supplier at the
          end of the trip; Drivons later invoices the supplier for platform
          commission.</li>
        </ul>

        <h2>5. Refunds and disputes</h2>
        <p>Refunds are handled per PayPal's refund window and Drivons's
        support team. Contact <a className="text-brand-accent underline" href="mailto:support@drivon.com">support@drivon.com</a> with your order id.</p>

        <h2>6. Prohibited use</h2>
        <p>No fraud, harassment, weapons/illegal goods transport, or use of
        the platform for anything unlawful. Violations result in immediate
        account suspension.</p>

        <h2>7. Liability</h2>
        <p>Drivons is not a transportation carrier. To the maximum extent
        permitted by law, Drivons is not liable for loss, damage, or injury
        arising from the acts or omissions of independent suppliers. Each
        supplier carries their own insurance.</p>

        <h2>8. Termination</h2>
        <p>You can delete your account at any time from Account → Delete my
        account. Drivons may suspend or terminate accounts that violate these
        terms.</p>

        <h2>9. Contact</h2>
        <p>Questions? Email <a className="text-brand-accent underline" href="mailto:support@drivon.com">support@drivon.com</a>.</p>
      </div>
    </Layout>
  );
}
